import { call, put, takeEvery } from 'redux-saga/effects'
import { GET_JOBS_LIST, GET_JOBS_LIST_FETCH_DONE } from '../actions/actionTypes';
import jobsList from '../data/jobs.json';

const apiUrl = `https://jsonplaceholder.typicode.com/users`;

function getOpenPositions() {
    return fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    }).then(response => response.json())
        .catch((error) => { throw error })
}

function* fetchOpenPositions(action) {
    try {
        yield call(getOpenPositions);
        yield put({ type: GET_JOBS_LIST_FETCH_DONE, payload: jobsList.jobs });
    } catch (e) {
        yield put({ type: 'GET_USERS_FAILED', message: e.message });
    }
}

function* openPositionsSaga() {
    yield takeEvery(GET_JOBS_LIST, fetchOpenPositions);
}

export default openPositionsSaga;